<template>
    <div>
        <div class="top-toolbox">
            <div class="left">
                <button
                    class="chatbot-btn"
                    :class="{ selected: selectedTab === 1 }"
                    @click="toggleSelectedTab(1)"
                    :disabled="previewMode"
                >
                    <md-icon>bolt</md-icon>
                </button>
                <button
                    class="chatbot-btn"
                    :class="{ selected: selectedTab === 2 }"
                    @click="toggleSelectedTab(2)"
                    :disabled="previewMode"
                >
                    <md-icon>search</md-icon>
                </button>
                <button
                    class="chatbot-btn"
                    :class="{ selected: selectedTab === 3 }"
                    @click="toggleSelectedTab(3)"
                    :disabled="previewMode"
                >
                    <md-icon>settings</md-icon>
                </button>
            </div>
            <div class="right">
                <SupsisButton
                    :primary="!automation.published"
                    :danger="automation.published"
                    :disabled="previewMode"
                    v-if="checkPermission(PERMISSION_TYPES['chatbot.stories.update'].tr.name)"
                    @click="() => (automation.published ? unPublishAutomation() : publishAutomation())"
                >
                    <span class="d-flex justify-content-between align-content-center align-items-center">
                        <span class="material-icons" style="">send</span>
                        <b class="ml-2" v-if="automation.published">Unpublish</b>
                        <b class="ml-2" v-else>{{ $t("chatbotv2.publish") }}</b>
                    </span>
                </SupsisButton>
            </div>
        </div>

        <div class="side-bar" v-if="selectedTab !== 0">
            <ActionPalette
                v-if="selectedTab === 1"
                :dragMode="dragMode"
                :dragStart="dragStart"
                :dragEnd="dragEnd"
                :addBlockToDiagram="addBlockToDiagram"
                :bar="selectedTab"
                @close-menu="selectedTab = $event"
            />
            <SearchWidget
                :blocksMetas="blocksMetas"
                @focusBlock="focusBlock"
                v-if="!previewMode && selectedTab === 2"
                :flattedDiagram="flattedDiagram"
                :toggleSelectedTab="toggleSelectedTab"
                :bar="selectedTab"
                @close-menu="selectedTab = $event"
                :automation="automation"
                :navigateTo="navigateTo"
            />
            <SettingsWidget
                @close-menu="selectedTab = $event"
                v-if="!previewMode && selectedTab === 3"
                :bar="selectedTab"
                :automation="automation"
            />
        </div>
    </div>
</template>

<script>
import ActionPalette from "./ActionPalette.vue";
import SearchWidget from "./SearchWidget.vue";
import SettingsWidget from "./SettingsWidget.vue";
import { log2 } from "../../../../../../utils/log2";
import { mapActions, mapGetters, mapState } from "vuex";
import { PERMISSION_TYPES } from "../../../../../../language/permissionTypes";
import _ from "lodash";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";
import SYSTEM_PUBSUB from "../../../../../../utils/systemPubSub";

const log = log2("Toolbar");

export default {
    name: "Toolbar",
    props: [
        "automation",
        "dragMode",
        "dragStart",
        "dragEnd",
        "addBlockToDiagram",
        "flattedDiagram",
        "blocksMetas",
        "defaultOpenBarIndex",
        "previewMode",
        "navigateTo",
    ],
    components: {
        SupsisButton,
        SettingsWidget,
        SearchWidget,
        ActionPalette,
    },
    computed: {
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        ...mapState({
            stories: (state) => state.CB.stories,
        }),
    },
    data() {
        return {
            selectedTab: this.previewMode ? 4 : 1,
        };
    },
    methods: {
        ...mapActions({
            publish: "automation/publishAutomation",
            unpublish: "automation/unPublishAutomation",
        }),
        publishAutomation() {
            console.log("publishAutomation");
            this.publish(this.automation._id)
                .then(() => {
                    this.$message.success("Automation published successfully");
                })
                .catch((err) => {
                    this.$message.error("Error while publishing automation");
                });
        },
        unPublishAutomation() {
            console.log("unPublishAutomation");
            this.unpublish(this.automation._id)
                .then(() => {
                    this.$message.success("Automation unpublished successfully");
                })
                .catch((err) => {
                    this.$message.error("Error while unpublishing automation");
                });
        },
        toggleSelectedTab(index) {
            if (this.selectedTab !== index) this.selectedTab = index;
            else this.selectedTab = 0;
        },
        focusBlock(block) {
            if (["START_POINT", "DEFAULT_FALLBACK"].includes(block.type)) return;
            if (block.type === "FLOW") {
                this.navigateToBlock(block);
                return;
            }
            this.$emit("openModal", block);
            let target = this.blocksMetas[`${block.id}`];
            let parentNode = this.blocksMetas[`${block.parent.id}`];
            log("focusBlock parentNode", parentNode.x, parentNode.y);
            log("focusBlock target", target.x, target.y);
            log("focusBlock block", block);
            parentNode.center = {
                x: parentNode.width / 4 - parentNode.x / 2,
                y: parentNode.height / 2 + parentNode.y / 2,
            };
            target.center = {
                x: target.x - parentNode.x + target.width / 2,
                y: target.y - parentNode.y + target.height / 2,
            };
            // log("focusBlock", target.center, parentNode.center);
            this.$emit("setTranslate", {
                diffX: parentNode.center.x - target.center.x,
                diffY: parentNode.center.y - target.center.y,
            });
        },
        publishHandler() {
            //todo refactor
        },
    },
    mounted() {
        this.eventBusSubscriber = SYSTEM_PUBSUB.stream.subscribe(({ type, payload }) => {
            if (type === SYSTEM_PUBSUB.MESSAGE_TYPES.AUTOMATION_CLOSE_TOOLBAR) {
                this.selectedTab = 0;
            }
        });
    },
    beforeDestroy() {
        this.eventBusSubscriber.unsubscribe();
    },
    watch: {
        selectedTab(val, oldVal) {},
    },
};
</script>

<style lang="scss" scoped>
.top-toolbox {
    position: absolute;
    top: 10px;
    right: 2rem;
    z-index: 999;
    gap: 6px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 4px 20px #00000040;
    height: 35px;
    width: auto;
    min-width: 250px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left,
    .right {
        display: flex;
        gap: 6px;
        align-items: center;
    }
}

.side-bar {
    position: absolute;
    top: 7rem;
    right: 2rem;
    z-index: 999;
    border-radius: 8px;
}

.chatbot-btn {
    border: none;
    background: #fff;
    border-radius: 4px;
    padding: 4px 8px;
    margin: 0;
    min-height: 34px;
    min-width: 34px;
    color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;

    &.bordered {
        border: 1px solid #000;
    }

    &.selected {
        .md-icon {
            color: #22272d !important;
        }
    }
}
</style>
